import {createLogger} from "@gongt/ts-stl-library/log/debug";
import {LOG_LEVEL} from "@gongt/ts-stl-library/log/levels";
import {ApiRequest, ApiResponse} from "@gongt/ts-stl-library/request/protocol";
import {ERequestType, getMethodName} from "@gongt/ts-stl-library/request/request";
import {resolve as resolveUrl} from "url";
import {inspect} from "util";
import {IUserProfileBase} from "../bridge/define";
import {UserCenterApiList} from "../bridge/user-center-api.generate";
import {UserError} from "../includes/user-error";
import {UserCenter} from "./user-center";
import request = require("request");

const debug = createLogger(LOG_LEVEL.INFO, 'http');
const notice = createLogger(LOG_LEVEL.NOTICE, 'http');
const data = createLogger(LOG_LEVEL.DATA, 'http');

export interface UserCenterStandardMethodCall<Request extends ApiRequest, Response extends ApiResponse> {
	(this: void, req: Request): Promise<Response>;
}

export class UserCenterApi<IProfile extends IUserProfileBase> extends UserCenterApiList<IProfile> {
	private baseUrl: string;
	
	constructor(private uc: UserCenter<IProfile>) {
		super();
		this.baseUrl = resolveUrl(uc.ucBaseUrl, '/api');
	}
	
	/** @internal */
	protected _do_request<Req extends ApiRequest, Res extends ApiResponse>
	(method: ERequestType, url: string, req: Req): Promise<Res> {
		if (!req.hasOwnProperty('project')) {
			req['project'] = this.uc.projectName;
		}
		return new Promise<Res>((resolve, reject) => {
			const r: request.OptionsWithUri = {
				baseUrl: this.baseUrl,
				json: true,
				uri: url,
				method: getMethodName(method),
				headers: {
					'X-Requested-With': 'XMLHttpRequest',
					'X-Server-Key': this.uc.serverKey,
					'Accept': 'text/json',
					encoding: 'utf-8',
					timeout: 10000,
				},
			};
			if (method === ERequestType.TYPE_GET) {
				r.qs = req;
			} else {
				r.body = req;
			}
			debug('start request: %s', inspect(r, false, 3, true).replace(/\s*[\n\r]+\s*/gm, ' '));
			request(r, (error: any, response: request.RequestResponse, body: any) => {
				if (error) {
					notice('  reject with error');
					data('      %j', body);
					reject(error);
				} else if (body && body.status === 0) {
					data('  resolve with 0: %j', body);
					resolve(body);
				} else if (body && body.status) {
					notice('  reject with status: %s', body.status);
					data('      %j', body);
					reject(body);
				} else {
					notice('  reject with empty error');
					data('      %j', body);
					reject(new UserError(`can't request api: ${url}`));
				}
			});
		});
	}
}
